import React, { FC, useEffect, useState } from 'react';

import classNames from 'classnames';

import { useIsActiveScroll, useMediaQuery } from 'hooks';
import { IconLogo, IconLogoEngText } from 'icons';
import { Button } from 'components';
import { LandingPageLinkKeys, LandingPageTextKeys } from 'service';
import { useTranslations } from 'context/translations';
import { IconHamburger } from 'icons/IconHamburger';

import styles from './Header.module.css';

export const Header: FC = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [show, setShow] = useState(true);
  const { t, link } = useTranslations();
  const isActive = useIsActiveScroll();
  const isMobile = useMediaQuery('(max-width: 600px)');
  const background = isActive ? 'visible' : 'transparent';
  const button =
    isActive && !openMenu && show ? 'button_visible' : 'button_hidden';
  const logo = isActive ? 'dark' : 'light';
  const buttonSize = isMobile ? 'small' : 'medium';
  const handleClick = () => setOpenMenu(!openMenu);

  useEffect(() => {
    const body = document.querySelector('body') as HTMLElement;
    if (openMenu) {
      body.style.overflow = 'hidden';
      setTimeout(() => setShow(false), 300);
    } else {
      body.style.overflow = 'auto';
      setTimeout(() => setShow(true), 300);
    }
  }, [openMenu]);

  return (
    <header
      style={openMenu ? { height: '100%' } : {}}
      className={classNames(
        styles[openMenu ? 'containerOpen' : 'container'],
        styles[background],
      )}
    >
      <div className={styles.logo_container}>
        {!isMobile || !isActive ? (
          <>
            <IconLogo className={styles.logo} id="1" />
            <IconLogoEngText
              className={classNames(styles.logo_text, styles[logo])}
              aria-label="Ornament"
            />
          </>
        ) : (
          <IconHamburger
            handleClick={handleClick}
            isActive={isActive}
            showAnim={show}
            isOpenMenu={openMenu}
          />
        )}
      </div>
      <div className={styles.button_container}>
        <Button
          size={buttonSize}
          view="primary"
          className={styles[button]}
          to={link(LandingPageLinkKeys.AffiliatesLink)}
        >
          {t(LandingPageTextKeys.IntroBlockButton)}
        </Button>
      </div>
      {isMobile && openMenu && !show && (
        <div className={styles.containerHamburger}>
          <Button
            size="large"
            view="primary"
            className={styles.button_startNow}
            to={link(LandingPageLinkKeys.AffiliatesLink)}
          >
            {t(LandingPageTextKeys.IntroBlockButton)}
          </Button>
        </div>
      )}
    </header>
  );
};
